import { Button, Flex, Space } from "antd"
import { Modal } from "ui/Modal"
import { Text, Title } from "ui/Typography"
import { Trans, useTranslation } from "react-i18next"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const CanNotDeleteClient = ({ open, onClose, handleViewBookingClick, clientName }) => {
  const { t } = useTranslation()
  return (
    <Modal open={open} onCancel={onClose} width={430} className={styles.canNotDeleteModal} centered>
      <Space className="w-full" direction="vertical" size={24}>
        <Flex justify="center">
          <WarningOutlinedWithBg />
        </Flex>
        <Title level={3}>{t("client.can_not_delete_client.title")}</Title>
        <Text>
          <Trans
            i18nKey="client.can_not_delete_client.text"
            values={{ name: clientName }}
            components={{ strong: <strong /> }}
          />
        </Text>
        <Flex gap={12}>
          <Button variant="outlined" color="primary" size="large" onClick={onClose}>
            {t("global.cancel")}
          </Button>
          <Button type="primary" size="large" onClick={handleViewBookingClick}>
            {t("client.can_not_delete_client.view_booking")}
          </Button>
        </Flex>
      </Space>
    </Modal>
  )
}

CanNotDeleteClient.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleViewBookingClick: PropTypes.func.isRequired,
  clientName: PropTypes.string
}

CanNotDeleteClient.defaultProps = {
  clientName: ""
}

export default CanNotDeleteClient
